// extracted by mini-css-extract-plugin
export default {"about_wrapper":"AboutMe_about_wrapper__W0zU5","about":"AboutMe_about__CQksv","navLine_link":"AboutMe_navLine_link__XLtJ6"};